export default __webpack_public_path__ + "static/media/USAworldwideTravelMulti.856e7d0a.jpg";